<div class="flex justify-end gap-2 mb-5">
  <p-button
    icon="fa fa-grid-2-plus"
    (click)="manageItems()"
    [label]="'inspectionItem.add' | translate"
    [disabled]="!inspection().id"
  />
</div>
<p-table
  #inspectionItemsTable
  [value]="inspectionItems()"
  stripedRows
  showGridlines
  dataKey="id"
  [resizableColumns]="true"
  columnResizeMode="expand"
  sortField="created_at"
  [sortOrder]="-1"
  [scrollable]="true"
  [loading]="false"
  [tableStyle]="{ 'min-width': '50rem' }"
  editMode="row"
>
  <ng-template #header>
    <tr>
      @for (column of inspectionItemColumns; track $index) {
        <th [pSortableColumn]="column.field" pResizableColumn>
          {{ column.header | translate }}
          @if (column.sortField) {
            <p-sortIcon [field]="column.sortField" />
          }
          @if (column.filterField) {
            <p-columnFilter
              [field]="column.filterField"
              display="menu"
              [type]="column.type"
              [matchMode]="column.matchMode"
              [showOperator]="column.showOperator || false"
              [showMatchModes]="column.showMatchModes || false"
              [showAddButton]="column.showAddButton || false"
            ></p-columnFilter>
          }
        </th>
      }
      <th frozen alignFrozen="right"></th></tr
  ></ng-template>
  <ng-template #body let-inspectionItem>
    <tr [pEditableRow]="inspectionItem">
      @for (column of inspectionItemColumns; track $index) {
        @switch (column.displayType) {
          @case ('text') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="inspectionItem[column.field]"
                    required
                  />
                </ng-template>
                <ng-template #output>
                  {{ inspectionItem[column.field] }}
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('tags') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  <p-multiselect
                    [options]="column.textOptions || []"
                    [(ngModel)]="inspectionItem[column.field]"
                    [placeholder]="
                      column.placeholder
                        ? (column.placeholder | translate)
                        : undefined
                    "
                    display="chip"
                    class="w-full md:w-80"
                  />
                </ng-template>
                <ng-template #output>
                  <div class="w-full md:w-80 flex">
                    @for (tag of inspectionItem[column.field]; track $index) {
                      <p-tag
                        [value]="tag.toLowerCase()"
                        severity="success"
                        styleClass="m-1"
                      />
                    }
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('boolean') {
            <td class="text-center">
              <p-cellEditor>
                <ng-template #input>
                  <p-toggleswitch [(ngModel)]="inspectionItem[column.field]" />
                </ng-template>
                <ng-template #output>
                  <i
                    class="text-2xl fa"
                    [ngClass]="{
                      'text-lime-500 fa-check-circle':
                        inspectionItem[column.field],
                      'text-red-500 fa-times-circle':
                        !inspectionItem[column.field],
                    }"
                  ></i>
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('date') {
            <td>
              <p-cellEditor>
                <ng-template #input>
                  <p-datepicker
                    [(ngModel)]="inspectionItem[column.field]"
                    [showIcon]="true"
                    dateFormat="dd.mm.yy"
                    class="w-full"
                  />
                </ng-template>
                <ng-template #output>
                  {{ inspectionItem[column.field] | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin' }}
                </ng-template>
              </p-cellEditor>
            </td>
          }
          @case ('progress') {
            <td>
              <p-progressbar [value]="round(inspectionItem[column.field] * 100)" />
            </td>
          }
          @case (null) {
            {{ inspectionItem[column.field] }}
          }
        }
      }
      <td frozen alignFrozen="right">
        <div class="flex items-center justify-end gap-1">
          @if (!inspectionItem.checked_at && canCheckItems) {
            <button
              pButton
              type="button"
              icon="fa fa-check"
              (click)="markAsChecked(inspectionItem)"
              text
              rounded
              severity="success"
              [pTooltip]="'inspectionItem.markChecked' | translate"
              tooltipPosition="top"
            ></button>
          }
          <button
            pButton
            type="button"
            icon="fa fa-triangle-exclamation"
            (click)="reportDefect(inspectionItem)"
            text
            rounded
            severity="warn"
            [pTooltip]="'inspectionItem.reportDefect' | translate"
            tooltipPosition="top"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
